import React, { useEffect, useState } from 'react'
import { Button, Col, Dropdown, Form, Modal, Row } from 'react-bootstrap'
import search from "../../assets/search.svg";
import '../auth/element.css';
import { callApi } from '../utills/api';
import { showAlert, showError, showSuccess } from '../utills/sweetAlert';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { faFile, faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactPaginate from 'react-paginate';
import TopNavBar from '../Layout/TopNavBar';
import upload from "../../assets/upload.svg";
import { useNavigate } from 'react-router-dom';

const { RangePicker } = DatePicker;

interface Vendor {
    id: number;
    site_name: string;
    location: string;
    create_date: string;
}

const ContactUs: React.FC = () => {

    const navigate = useNavigate();

    const [siteDetails, setSiteDetails] = useState<any[]>([]);

    const [state, setState] = useState({
        CatId: "",
        MasterId: "",
        SubcategoryName: "",
        MasterOptionselect: [],
        name: "",
        description: "",
        starCount: "",
        role: "",
        image: "",
        id: "",
    });


    const siteShow = () => {
        navigate('/layout/addblog');   
    };

   

    useEffect(() => {
        tableCategoryShow();
    }, []);

    const tableCategoryShow = () => {
        callApi("GET", "contactselect.php", "")
            .then((res) => res.data)
            .then((response) => {
                if (response) {
                    console.log("response--->", response.data);
                    setSiteDetails(response.data);
                    console.log("siteDetails--->", siteDetails);
                }
            })
            .catch((err: any) => {
                console.error(
                    "API call error:",
                    err.response ? err.response.data.error : err.message
                );
                showError(
                    "Failed",
                    err.response ? err.response.data.error : err.message
                );
            });
    }


    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 10;
    const [searchTerm, setSearchTerm] = useState("");
    const handleSearch = (term: string) => {
        setSearchTerm(term);
    };

    const filteredData = siteDetails.filter((item: any) =>
        Object.values(item).some((value) =>
            (value as string).toString().toLowerCase().includes(searchTerm.toLowerCase())
        )
    );

    // Calculate pagination for filtered data
    const pageCount = Math.ceil(filteredData.length / itemsPerPage);
    const offset = currentPage * itemsPerPage;
    const currentData = filteredData.slice(offset, offset + itemsPerPage);
    const handlePageClick = (event: { selected: number }) => {
        setCurrentPage(event.selected);
    };

    // Calculate the display range for the items
    const startItem = offset + 1;
    const endItem = Math.min(offset + itemsPerPage, filteredData.length);


    const deleteApi = async (id: any) => {
        const isComfirm = await showAlert(
            "Please Confirm",
            `Are you sure you want to Delete ?`,
            "Yes",
            "No"
        );
        if (isComfirm) {
            let req = {
                id: id,
            };
            callApi("POST", "contactdelete.php", req)
                .then((res) => res.data)
                .then((response) => {
                    if (response) {
                        showSuccess("Success!", "Contact Deleted Successfully!");

                        tableCategoryShow();
                    }
                })
                .catch((err: any) => {
                    console.error(
                        "API call error:",
                        err.response ? err.response.data.error : err.message
                    );
                    showError(
                        "Failed",
                        err.response ? err.response.data.error : err.message
                    );
                });
        }
    }
    return (
        <>
            <div>
                <div className="mobile_nav_bar">
                    <TopNavBar />
                </div>
                <div className="">
                    <Row className='webview'>
                        <div className="category-header">
                            <Col lg="8" md="8">
                                <h3 className="category-title">
                                    ContactUs 
                                </h3>
                            </Col>
                            <Col lg="4" md="4" className="headbtn">
                                <div className="search-bar">
                                    <img
                                        src={search}
                                        alt="search-icon"
                                        style={{ width: "22px" }}
                                    />
                                    <input type="text" placeholder="Search..."
                                        onChange={(e) => handleSearch(e.target.value)} />
                                </div>
                            </Col>
                        </div>
                    </Row>

                </div>

                <div className="element-container">

                    {filteredData.length > 0 ? (
                        <div className="table-container">
                            <table className="custom-table">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th> Name</th>
                                        <th>Email</th>
                                        <th>Phone Number</th>
                                        <th>Comments</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentData.map((item, index) => (
                                        <tr key={item.id}>
                                            <td
                                            style={{padding:"20px 2px"}}>
                                               {offset + index + 1}
                                            </td>
                                            <td className='boldtd'>{item.name}</td>
                                            <td>
                                                <span >
                                                    {item.email}
                                                </span>
                                            </td>
                                            <td>
                                                <span >
                                                    {item.phoneNumber}
                                                </span>
                                            </td>  <td>
                                                <span >
                                                    {item.Comments}
                                                </span>
                                            </td>
                                            <td>
                                                <div className='webview'>
                                                    <Dropdown align="end">
                                                        <Dropdown.Toggle
                                                            variant="link"
                                                            id="dropdown-basic"
                                                            style={{ border: "none", background: "transparent" }}
                                                        ></Dropdown.Toggle>
                                                        <Dropdown.Menu
                                                            id="webdropdown">
                                                           
                                                            <Dropdown.Item
                                                                onClick={() => deleteApi(item.id)}
                                                            >
                                                                Delete
                                                            </Dropdown.Item>

                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                                
                                            </td>
                                           

                                          
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className="pagination-container">
                                <div className="pagination-info">
                                    {`${startItem} - ${endItem} of ${filteredData.length}`}
                                </div>
                                <ReactPaginate
                                    previousLabel={'<'}
                                    nextLabel={'>'}
                                    breakLabel={'...'}
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={3}
                                    onPageChange={handlePageClick}
                                    containerClassName={'pagination'}
                                    activeClassName={'active-page'}
                                    pageClassName={'page-item'}
                                    previousClassName={'prev-next'}
                                    nextClassName={'prev-next'}
                                />
                            </div>
                        </div>
                    ) : (
                        <p className='nodata'>Data Not Found</p>
                    )}
                </div>
            </div>

            </>
    )
}

export default ContactUs